// @ts-check
import { generateMock } from '@anatine/zod-mock';
import { faker } from '@faker-js/faker';

import { documentSchema, documentRoleSchema } from '@/data/schema/documents';

/** @typedef {import('@/data/schema/documents').TDocument} TDocument */
/** @typedef {import('@/data/schema/documents').TDocumentRole} TDocumentRole */

/** @param {Partial<TDocument>} [properties] */
export function createDocument(properties = {}) {
  const document = generateMock(documentSchema, {
    stringMap: {
      fingerprint: () => faker.string.uuid(),
      title: () =>
        [
          faker.color.human().toUpperCase(),
          faker.music.genre(),
          faker.hacker.verb(),
        ].join(' '),
    },
  });

  return { ...document, ...properties };
}

/**
 * @param {number} count
 * @param {Partial<TDocument>[]} [properties]
 */
export function createDocuments(count, properties = []) {
  return Array.from(Array(count), (_, index) =>
    createDocument(properties[index]));
}

/** @param {Partial<TDocumentRole>} [properties] */
export function createDocumentRole(properties = {}) {
  const documentRole = generateMock(documentRoleSchema, {
    stringMap: { title: () => faker.animal.bird(), role: () => 'signer' },
  });

  return { ...documentRole, ...properties };
}

/**
 * @param {number} count
 * @param {Partial<TDocumentRole>[]} [properties]
 */
export function createDocumentRoles(count, properties = []) {
  return Array.from(Array(count), (_, index) =>
    createDocumentRole(properties[index]));
}
